import React from 'react';
import DayCell from './day';
import MonthCell from './month';
import QuarterCell from './quarter';
import HeaderCells, { type APIProps } from './view';
import WeekCell from './week';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (props: APIProps) => (
	// @ts-expect-error - TS2769 - No overload matches this call.
	<HeaderCells
		{...props}
		DayCell={DayCell}
		WeekCell={WeekCell}
		MonthCell={MonthCell}
		QuarterCell={QuarterCell}
	/>
);

export type { APIProps };
